<script lang="ts" setup></script>

<template>
  <Suspense>
    <template #default>
      <RouterView />
    </template>
    <template #fallback>
      <p>asdf</p>
    </template>
  </Suspense>
</template>

<style scoped></style>
